<template>
    <div class="layer-filter">
        <div class="layer-filter-top">{{ $t('gridManage.layerFilter') }}</div>
        <div class="layer-filter-item" v-for="item in itemList" :key="item.bg">
            <div class="layer-filter-item-icon" :style="`background:${item.bg}`"></div>
            <p class="layer-filter-item-name">{{ item.name }}</p>
            <el-checkbox style="margin-left: 10px" v-model="item.checkValue"></el-checkbox>
        </div>
    </div>
</template>

<script>
export default {
    props: ['getGridList'],
    data() {
        return {
            isPlanned: false,
            itemList: [
                {
                    bg: `url(${require('../mapComponents/imgs/icon_col-1.png')}) center center / 20px 20px`,
                    name: this.$t('gridManage.plannedRoute'),
                    checkValue: true,
                },
                {
                    bg: '#70b603',
                    name: this.$t('gridManage.flyable'),
                    checkValue: true,
                },
                {
                    bg: '#ec808d',
                    name: this.$t('gridManage.noFly'),
                    checkValue: true,
                },
                {
                    bg: '#d7d7d7',
                    name: this.$t('gridManage.disabled'),
                    checkValue: true,
                },
            ],
        };
    },
    watch: {
        itemList: {
            deep: true,
            handler() {
                this.getGridList();
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.layer-filter {
    position: absolute;
    left: 350px;
    bottom: 20px;
    color: black;
    background-color: #f2f2f2;
    padding: 8px;
    line-height: 20px;
    .layer-filter-item {
        display: flex;
        margin-top: 8px;
        font-size: 14px;
        .layer-filter-item-icon {
            width: 20px;
            height: 20px;
        }
    }
    .layer-filter-item-name {
        margin-left: 5px;
        width: 70px;
    }
}
</style>
